import { render } from "./BaseDropdown.vue?vue&type=template&id=fd4dad32"
import script from "./BaseDropdown.vue?vue&type=script&lang=js"
export * from "./BaseDropdown.vue?vue&type=script&lang=js"

import "./BaseDropdown.vue?vue&type=style&index=0&id=fd4dad32&lang=css"

import exportComponent from "/codebuild/output/src407097413/src/Abbott-Seguimiento-Email-Backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__